<template>
	<div>
		<AppHeader title="지점 찾기" />

		<AppContent>
			<ShopDetail />
		</AppContent>

		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppFooter from '@/components/common/AppFooter';
import AppContent from '@/components/common/AppContent';

import ShopDetail from '@/components/shop';

export default {
	components: {
		AppHeader,
		AppFooter,
		AppContent,
		ShopDetail,
	},
};
</script>
